import { getIconName } from "@/utils/mode-commande";

export const produitsIncompatiblesFormProps = () => ({
  produitsIncompatibles: {
    type: Array,
    required: false,
    default: []
  },
  modeCommande: {
    type: Object,
    required: false,
    default: null
  }
})

export const produitsIncompatiblesFormEmits = () => ([
  "deleteProduitsIncompatibles"
])

export const useProduitsIncompatiblesForm = (props, context) => {
  const iconName = computed(() => {
    return getIconName(props.modeCommande.type_picto.code);
  })

  const deleteProduitsIncompatibles = () => {
    context.emit("deleteProduitsIncompatibles");
  }

  return {
    iconName,
    deleteProduitsIncompatibles
  }
}